export function ArrowUp() {
  return (
    <path
      fill="currentColor"
      d="M13 20h-2V8l-5.5 5.5l-1.42-1.42L12 4.16l7.92 7.92l-1.42 1.42L13 8z"
    />
  )
}
